import React, { useState } from "react";
import { MotifButton, MotifTextArea, MotifFormField } from "@ey-xd/motif-react";

const MAX_CHARS = 2000;

const CommentInput = ({
  onSubmit,
  placeholder = "Write a comment...",
  submitLabel = "Post",
  autoFocus = false,
  onCancel,
  showCancel = false,
}) => {
  const [text, setText] = useState("");

  const handleChange = (e) => {
    const val = e?.target?.value ?? "";
    setText(val);
  };

  const handleSubmit = () => {
    const trimmed = (text || "").trim();
    if (!trimmed || text.length > MAX_CHARS) return;
    onSubmit(trimmed);
    setText("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && (e.ctrlKey || e.metaKey)) {
      e.preventDefault();
      handleSubmit();
    }
    if (e.key === "Escape" && onCancel) {
      onCancel();
    }
  };

  return (
    <div className="comment-input">
      <MotifFormField>
        <MotifTextArea
          value={text}
          onChange={handleChange}
          placeholder={placeholder}
          autoFocus={autoFocus}
          onKeyDown={handleKeyDown}
          rows={2}
          maxLength={MAX_CHARS}
        />
      </MotifFormField>
      <div className="comment-input-actions">
        {showCancel && onCancel && (
          <MotifButton
            variant="secondary"
            size="small"
            onClick={onCancel}
            type="button"
          >
            Cancel
          </MotifButton>
        )}
        <MotifButton
          variant="primary"
          size="small"
          onClick={handleSubmit}
          disabled={!(text || "").trim() || text.length > MAX_CHARS}
          type="button"
        >
          {submitLabel}
        </MotifButton>
      </div>
    </div>
  );
};

export default CommentInput;
